import { createElement } from "react";
import { Wrapper, Icon } from "nystem-components";

const types = {
  primary: "bg-blue-600 hover:bg-blue-700 text-white",
  secondary: "bg-gray-800 hover:bg-gray-700 text-gray-200 border border-gray-700",
  danger: "bg-red-700 hover:bg-red-600 text-white",
  warning: "bg-yellow-600 hover:bg-yellow-500 text-white",
  success: "bg-green-600 hover:bg-green-500 text-white",
  info: "btn",
  error: "btn",
  default: "bg-gray-800 hover:bg-gray-700 text-gray-200 border border-gray-700",
  primaryDisabled: "bg-blue-400 cursor-not-allowed",
  secondaryDisabled: "bg-gray-600 text-white cursor-not-allowed",
  dangerDisabled: "bg-red-400 text-white cursor-not-allowed",
  warningDisabled: "bg-yellow-300 text-white cursor-not-allowed",
  infoDisabled: "btn",
  errorDisabled: "btn",
  defaultDisabled: "bg-gray-800 text-gray-500 border border-gray-700",
};

const sizes = {
  xs: "py-1 px-2 text-xs",
  sm: "py-1 px-2 text-sm",
  base: "py-2 px-4 text-base",
  lg: "py-4 px-6 text-lg",
  xl: "py-4 px-8 text-xl",
  "2xl": "py-4 px-8 text-xl2",
};

const Button = ({ onClick, className = [], type, size, disabled, icon, ...props }) => {
  className = className instanceof Array ? [...className] : [className];

  className.push(disabled ? "rounded shadow-sm cursor-not-allowed" : "rounded shadow-sm cursor-pointer");
  className.push(sizes[size] || sizes.base);
  className.push(types[(type || "default") + (disabled ? "Disabled" : "")]);
  if (icon) {
    props.title ||= typeof props.children === "string" ? props.children : undefined;
    props["aria-label"] ||= props.title;
    props.children = <Icon icon={icon} className="h-5 w-5" />;
    className.push("inline-flex items-center justify-center");
  }

  if (props.Component) return createElement(props.Component, { className, ...props });

  return (
    <Wrapper
      renderAs="button"
      disabled={disabled}
      className={className}
      {...props}
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
    />
  );
};
export default Button;
